  const formatUTCDate = (value) => {
  if (!value) return "N/A";

  const fechaUTC = new Date(value);

  if (Number.isNaN(fechaUTC.getTime())) return value;

  return `${fechaUTC.getUTCFullYear()}-${String(
    fechaUTC.getUTCMonth() + 1
  ).padStart(2, "0")}-${String(fechaUTC.getUTCDate()).padStart(2, "0")} ${String(
    fechaUTC.getUTCHours()
  ).padStart(2, "0")}:${String(fechaUTC.getUTCMinutes()).padStart(
    2,
    "0"
  )}:${String(fechaUTC.getUTCSeconds()).padStart(2, "0")}`;
};

const columns = [
  { field: "id", headerName: "ID", width: 90 },
  { field: "tipoMaquinaControl", headerName: "Tipo de Máquina y Control", minWidth: 220, flex: 1 },
  { field: "numeroEquipo", headerName: "Número de Equipo", minWidth: 160, flex: 1 },
  { field: "fecha", headerName: "Fecha", minWidth: 180, flex: 1 },
  { field: "tempEvaporadorSalida", headerName: "Temp Evaporador Salida", minWidth: 200, flex: 1 },
  { field: "tempDescarga", headerName: "Temp Descarga", minWidth: 180, flex: 1 },
  { field: "presionSuccion", headerName: "Presión Succión", minWidth: 180, flex: 1 },
  { field: "presionDescarga", headerName: "Presión Descarga", minWidth: 180, flex: 1 },
  { field: "porcVelVentEcGrupo1", headerName: "Porcentaje Velocidad Ventilador EC Grupo 1", minWidth: 280, flex: 1 },
  { field: "porcVelVentEcGrupo2", headerName: "Porcentaje Velocidad Ventilador EC Grupo 2", minWidth: 280, flex: 1 },
  { field: "voltaje", headerName: "Voltaje", minWidth: 140, flex: 1 },
  { field: "amperaje", headerName: "Amperaje", minWidth: 140, flex: 1 },
  { field: "sobrecalentamiento", headerName: "Sobrecalentamiento", minWidth: 180, flex: 1 },
  { field: "tempSuccion", headerName: "Temp Succión", minWidth: 160, flex: 1 },
  { field: "condicionActual", headerName: "Condición Actual", minWidth: 200, flex: 1 },
  { field: "controlCarga", headerName: "Control de Carga", minWidth: 180, flex: 1 },
  { field: "ramploading", headerName: "Ramploading", minWidth: 160, flex: 1 },
  { field: "interlockComp1", headerName: "Interlock Comp 1", minWidth: 180, flex: 1 },
  { field: "statusMotorProtect1", headerName: "Status MotorProtect 1", minWidth: 200, flex: 1 },
  { field: "nivelAceiteCarter", headerName: "Nivel de Aceite Carter", minWidth: 200, flex: 1 },
  { field: "switchFlujoAguaHelada", headerName: "Switch Flujo Agua Helada", minWidth: 210, flex: 1 },
  { field: "protectorBajaPresion", headerName: "Protector Baja Presión", minWidth: 190, flex: 1 },
  { field: "encendidoCompresor1", headerName: "Encendido Compresor 1", minWidth: 200, flex: 1 },
  { field: "load", headerName: "Load", minWidth: 140, flex: 1 },
  { field: "unload", headerName: "Unload", minWidth: 140, flex: 1 },
  { field: "activaExv", headerName: "Activa EXV", minWidth: 160, flex: 1 },
  { field: "solenoideInyeccionSuccion", headerName: "Solenoide Inyección Succión", minWidth: 230, flex: 1 },
  { field: "ventiladorGrupo1Ec", headerName: "Ventilador Grupo 1 EC", minWidth: 200, flex: 1 },
  { field: "fechaFalla1", headerName: "Fecha de Falla 1", minWidth: 180, flex: 1 },
  { field: "numFalla1", headerName: "Num Falla 1", minWidth: 220, flex: 1 },
  { field: "fechaFalla2", headerName: "Fecha de Falla 2", minWidth: 180, flex: 1 },
  { field: "numFalla2", headerName: "Num Falla 2", minWidth: 220, flex: 1 },
  { field: "fechaFalla3", headerName: "Fecha de Falla 3", minWidth: 180, flex: 1 },
  { field: "numFalla3", headerName: "Num Falla 3", minWidth: 220, flex: 1 },
  { field: "fechaFalla4", headerName: "Fecha de Falla 4", minWidth: 180, flex: 1 },
  { field: "numFalla4", headerName: "Num Falla 4", minWidth: 220, flex: 1 },
  { field: "fechaFalla5", headerName: "Fecha de Falla 5", minWidth: 180, flex: 1 },
  { field: "numFalla5", headerName: "Num Falla 5", minWidth: 220, flex: 1 },
  { field: "tiempoServicioHoras", headerName: "Tiempo de Servicio en Horas", minWidth: 230, flex: 1 },
  { field: "horasTotalesOperacion", headerName: "Horas Totales de Operación", minWidth: 220, flex: 1 },
];

const mapRow = (row, index) => ({
  id: index + 1,
  tipoMaquinaControl: row["Tipo de Máquina y Control"],
  numeroEquipo: row["Número de Equipo"],
  fecha: formatUTCDate(row["Fecha"]),
  tempEvaporadorSalida: row["Temp Evaporador Salida"],
  tempDescarga: row["Temp Descarga"],
  presionSuccion: row["Presión Succión"],
  presionDescarga: row["Presión Descarga"],
  porcVelVentEcGrupo1: row["Porcentaje Velocidad Ventilador EC Grupo 1"],
  porcVelVentEcGrupo2: row["Porcentaje Velocidad Ventilador EC Grupo 2"],
  voltaje: row["Voltaje"],
  amperaje: row["Amperaje"],
  sobrecalentamiento: row["Sobrecalentamiento"],
  tempSuccion: row["Temp Succión"],
  condicionActual: row["Condición Actual"],
  controlCarga: row["Control de Carga"],
  ramploading: row["Ramploading"],
  interlockComp1: row["Interlock Comp 1"],
  statusMotorProtect1: row["Status MotorProtect 1"],
  nivelAceiteCarter: row["Nivel de Aceite Carter"],
  switchFlujoAguaHelada: row["Switch Flujo Agua Helada"],
  protectorBajaPresion: row["Protector Baja Presión"],
  encendidoCompresor1: row["Encendido Compresor 1"],
  load: row["Load"],
  unload: row["Unload"],
  activaExv: row["Activa EXV"],
  solenoideInyeccionSuccion: row["Solenoide Inyección Succión"],
  ventiladorGrupo1Ec: row["Ventilador Grupo 1 EC"],
  fechaFalla1: formatUTCDate(row["Fecha de Falla 1"]),
  numFalla1: row["Num Falla 1"] || "N/A",
  fechaFalla2: formatUTCDate(row["Fecha de Falla 2"]),
  numFalla2: row["Num Falla 2"] || "N/A",
  fechaFalla3: formatUTCDate(row["Fecha de Falla 3"]),
  numFalla3: row["Num Falla 3"] || "N/A",
  fechaFalla4: formatUTCDate(row["Fecha de Falla 4"]),
  numFalla4: row["Num Falla 4"] || "N/A",
  fechaFalla5: formatUTCDate(row["Fecha de Falla 5"]),
  numFalla5: row["Num Falla 5"] || "N/A",
  tiempoServicioHoras: row["Tiempo de Servicio en Horas"],
  horasTotalesOperacion: row["Horas Totales de Operación"],
});

export const fullServiceCoolingV2_1CompConsultaConfig = {
  title: "FULL SERVICE COOLING V2 1COMP",
  endpoint:
    "https://lndvjnxrzb.execute-api.us-east-2.amazonaws.com/test/consulta/fullservicecoolingv21comp/datos",
  buildRequestBody: ({ idEquipo, fechaInicio, fechaFinal }) => ({
    idEquipo,
    fechaInicio,
    fechaFinal,
    tipoMaquina: "Full Service Cooling V2 1Comp",
    tipoConsulta: "Datos",
  }),
  columns,
  mapRow,
};